﻿import { OpaccFilter } from './opacc.class.filter.js';

export const opaccFilterPlugin = new OpaccFilter();